import React, { useEffect } from "react";
import { useParams } from "react-router";
import { useState } from "react";
import Moralis from "moralis";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import Web3 from "web3";
import button_spinner from "../images/Rolling.gif";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useMoralis } from "react-moralis";

const Singlenft = () => {
  var abi = [
    {
      inputs: [],
      stateMutability: "nonpayable",
      type: "constructor",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "approved",
          type: "address",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "Approval",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "operator",
          type: "address",
        },
        {
          indexed: false,
          internalType: "bool",
          name: "approved",
          type: "bool",
        },
      ],
      name: "ApprovalForAll",
      type: "event",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "approve",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "awardWinner",
      outputs: [],
      stateMutability: "payable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "burn",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "buyNft",
      outputs: [],
      stateMutability: "payable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "closeAuction",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "string",
          name: "uri",
          type: "string",
        },
        {
          internalType: "uint256",
          name: "price",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "saleNumber",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "auctionTime",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "royality",
          type: "uint256",
        },
      ],
      name: "mintToken",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "previousOwner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "OwnershipTransferred",
      type: "event",
    },
    {
      inputs: [],
      name: "pause",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "address",
          name: "account",
          type: "address",
        },
      ],
      name: "Paused",
      type: "event",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "bidAmount",
          type: "uint256",
        },
        {
          internalType: "address",
          name: "mmo_address",
          type: "address",
        },
      ],
      name: "placeBid",
      outputs: [],
      stateMutability: "payable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "purchase",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "auctionTimeNeeded",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "minPrice",
          type: "uint256",
        },
      ],
      name: "putOnAuction",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "price",
          type: "uint256",
        },
      ],
      name: "putOnSale",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "removeNft",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "renounceOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "retriveFromSale",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "string",
          name: "uri",
          type: "string",
        },
      ],
      name: "safeMint",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "safeTransferFrom",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          internalType: "bytes",
          name: "_data",
          type: "bytes",
        },
      ],
      name: "safeTransferFrom",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "operator",
          type: "address",
        },
        {
          internalType: "bool",
          name: "approved",
          type: "bool",
        },
      ],
      name: "setApprovalForAll",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "Transfer",
      type: "event",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "transferOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "address",
          name: "account",
          type: "address",
        },
      ],
      name: "Unpaused",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "uint256",
          name: "id",
          type: "uint256",
        },
        {
          indexed: false,
          internalType: "string",
          name: "uri",
          type: "string",
        },
      ],
      name: "tokenMinted",
      type: "event",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "transferFrom",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "receiver",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "amount",
          type: "uint256",
        },
        {
          internalType: "address",
          name: "mmoAddress",
          type: "address",
        },
      ],
      name: "transfermmo",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "unpause",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "price",
          type: "uint256",
        },
      ],
      name: "updatePrice",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address",
        },
      ],
      name: "balanceOf",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getApproved",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getAuctionWinner",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "string",
          name: "uri",
          type: "string",
        },
      ],
      name: "getIdbyUri",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getMinBidPrice",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getNftCreator",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getNftRoyality",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getNumberOfBids",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getPrice",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getRemainingBidingTime",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getRunnerup",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getRunnerupBid",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getWinningBid",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getWinningBider",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          internalType: "address",
          name: "operator",
          type: "address",
        },
      ],
      name: "isApprovedForAll",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "isNftForSale",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "isNftOnAuction",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "name",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "owner",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "ownerOf",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "paused",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "bytes4",
          name: "interfaceId",
          type: "bytes4",
        },
      ],
      name: "supportsInterface",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "symbol",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "index",
          type: "uint256",
        },
      ],
      name: "tokenByIndex",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "index",
          type: "uint256",
        },
      ],
      name: "tokenOfOwnerByIndex",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "tokenURI",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "totalSupply",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
  ];

  /*--------------------------
           USE EFFECT
     -------------------------   */
  useEffect(() => {
    getSingleNftDetails(id);
  }, []);

  var nftDetailsArray = [];
  const { id } = useParams();
  const { user } = useMoralis();
  const [loading, setLoading] = useState(false);
  const [nftRoyality, setnftRoyality] = useState(null);
  const [nftPrice, setnftPrice] = useState(null);
  const [minBid, setMinBid] = useState(null);
  const [heighestBid, setHeighestBid] = useState(null);
  const [nftOwner, setnftOwner] = useState(null);
  const [forSale, setForSale] = useState(false);
  const [forAuction, setForAuction] = useState(false);
  const [singleNftCreator, setSingleNftCreator] = useState(null);
  const [nftDetails, setNftDetails] = useState([]);
  const [ownerVisit, setOwnerVisit] = useState(false);
  const [isBiddingOpen, setIsBiddingOpen] = useState(false);
  const [isTheirBidder, setisTheirBidder] = useState(false);
  const mmo_wallet_address = "0x9F7907c38690c18ad4e0999F891D4133f63bdc1B";
  const mmo_contract_address = "0x0aa086e7a108d387de63294fe2a88b05820a9855";
  const contractAddress = "0x0c24491c7CadACc878474047c5d7972340D392C3";
  Moralis.start({
    serverUrl: "https://kquqmy2unesf.usemoralis.com:2053/server",
    appId: "lGFqxutUnQZXqqxy5N1optlMEzpT6RJW7BwbcMmw",
  });

  /*Transfer Rest Function*/

  async function awardWinner() {
    alert("award Winner Clicked");
    const contract_address = "0x0c24491c7CadACc878474047c5d7972340D392C3";
    const contract_abi = abi;
    const web3 = new Web3(window.ethereum);
    const contract = new web3.eth.Contract(contract_abi, contract_address);
    const accounts = await web3.eth.getAccounts();

    contract.methods
      .awardWinner(id)
      .send({ from: accounts[0] })
      .then(function (awardWinnerRes) {
        if (awardWinnerRes.status) {
          toast.success("Winner is Awarded", { theme: "colored" });
        }
      });
  }

  /*-------------------------------------
        PURCHASE FUNCTION
   ---------------------------------------*/
  async function purchase() {
    console.log(nftPrice);

    setLoading(true);
    const mmo_commission = (2 / 100) * nftPrice;
    const creator_royality = (nftRoyality / 100) * nftPrice;
    const price_after_deductions = nftPrice - mmo_commission - creator_royality;
    console.log(creator_royality);
    console.log(mmo_commission);
    console.log(price_after_deductions);
    console.log("This is nft Creator" + singleNftCreator);
    console.log("This is owner of nft" + nftOwner);
    /* Pay to owner First*/
    const mmo_commision_options = {
      type: "erc20",
      amount: Moralis.Units.Token(price_after_deductions, "18"),
      receiver: nftOwner,
      contractAddress: mmo_contract_address,
    };
    let result = await Moralis.transfer(mmo_commision_options);
    if (result.status) {
      /*pay Royality*/
      const pay_royality_options = {
        type: "erc20",
        amount: Moralis.Units.Token(creator_royality, "18"),
        receiver: singleNftCreator,
        contractAddress: mmo_contract_address,
      };
      let pay_royality_result = await Moralis.transfer(pay_royality_options);
      if (pay_royality_result.status) {
        /*Pay MMO Commission */
        const pay_commission_options = {
          type: "erc20",
          amount: Moralis.Units.Token(mmo_commission, "18"),
          receiver: mmo_wallet_address,
          contractAddress: mmo_contract_address,
        };
        let pay_commission_result = await Moralis.transfer(
          pay_commission_options
        );
        if (pay_commission_result.status) {
          /*DO THE TRANSFER*/
          const contract_address = "0x0c24491c7CadACc878474047c5d7972340D392C3";
          const contract_abi = abi;
          const web3 = new Web3(window.ethereum);
          const accounts = await web3.eth.getAccounts();
          const contract = new web3.eth.Contract(
            contract_abi,
            contract_address
          );
          contract.methods
            .purchase(id)
            .send({ from: accounts[0] })
            .then(function (purchaseRes) {
              if (purchaseRes.status) {
                toast.success("NFT Purchased Successfully", {
                  theme: "colored",
                });
              }
            });

          //toast.success("MMO deducted. Transfering NFT", {theme: "colored" })
        }
      }
    }
    console.log(result.status);
    setLoading(false);
  }

  /*---------------------------------
          Biding Function
  -----------------------------------*/
  async function placeBid() {
    const bidPlacingAmount = document.getElementById("entred_bid_amount").value;
    const bidPlacingAmountEth = Web3.utils.toWei(bidPlacingAmount, "ether");
    const myBidInt = parseInt(bidPlacingAmount);
    const bigestBid = parseInt(heighestBid);
    const minBidInt = parseInt(minBid);
    if (myBidInt < minBidInt) {
      alert("Bid must be Greater than " + minBidInt);
    } else if (myBidInt <= bigestBid) {
      alert(
        "your entred amount is: " +
          bidPlacingAmount +
          " But Heighest Bid is " +
          heighestBid
      );
    } else {
      const deductable_bid_amount_options = {
        type: "erc20",
        amount: Moralis.Units.Token(bidPlacingAmount, "18"),
        receiver: "0x0c24491c7CadACc878474047c5d7972340D392C3",
        contractAddress: mmo_contract_address,
      };
      let placeBidresult = await Moralis.transfer(
        deductable_bid_amount_options
      );
      //console.log(placeBidresult);
      if (placeBidresult.status) {
        console.log("MMO deducted from user");
        const contract_address = "0x0c24491c7CadACc878474047c5d7972340D392C3";
        const contract_abi = abi;
        const web3 = new Web3(window.ethereum);
        const accounts = await web3.eth.getAccounts();
        const contract = new web3.eth.Contract(contract_abi, contract_address);
        const bidingRunnerUpAddress = await contract.methods
          .getRunnerup(id)
          .call();
        const bidingRunnerUpBid = await contract.methods
          .getRunnerupBid(id)
          .call();
        contract.methods
          .placeBid(id, bidPlacingAmountEth, mmo_contract_address)
          .send({ from: accounts[0] })
          .then(function (placeBidRes) {
            if (placeBidresult.status) {
              console.log("Highest and Runnerup Bids updated");
              console.log(bidingRunnerUpAddress);
              console.log(bidingRunnerUpBid);
              console.log("mmo Contract" + mmo_contract_address);

              contract.methods
                .transfermmo(
                  bidingRunnerUpAddress,
                  bidingRunnerUpBid,
                  mmo_contract_address
                )
                .send({ from: accounts[0] })
                .then(function (mmotransferRes) {
                  if (mmotransferRes.status) {
                    console.log("Runner up Bidder is Paye back");
                    toast.success("Bid Placed Successfully", {
                      theme: "colored",
                    });
                  }
                });
            }
          });
      }
    }
    //
    //alert("place Bid is clicked")
    /*     const mmo_commision_options = {type: "erc20", amount: Moralis.Units.Token(price_after_deductions , "18"), receiver: nftOwner,
    contractAddress: mmo_contract_address}
    let result = await Moralis.transfer(mmo_commision_options) */
  }

  /*----------------------------
      Resell Function
  ------------------------------*/
  async function resellFixed() {
    // alert("resell Fixed is Clieked");
    const resellFixedPrice = document.getElementById("resell_price").value;

    const auction_btn = document.getElementById("resell_auction_btn");
    auction_btn.disabled = true;

    const id_to_resell = id;
    const contract_abi = abi;
    const web3 = new Web3(window.ethereum);
    const resellEthPrice = web3.utils.toWei(resellFixedPrice, "ether");
    const accounts = await web3.eth.getAccounts();
    const contract = new web3.eth.Contract(contract_abi, contractAddress);

    try {
      contract.methods
        .putOnSale(id_to_resell, resellEthPrice)
        .send({ from: accounts[0] })
        .then(function (resellRes) {
          if (resellRes) {
            toast.success("NFT placed on Sale", { theme: "colored" });
          } else {
            toast.error("An Error Accoured, Please try again later", {
              theme: "colored",
            });
          }
        });
    } catch (error) {
      alert(error);
    }
  }
  async function resellAuction() {
    const fixed_btn = document.getElementById("resell_fixed_btn");
    fixed_btn.disabled = true;
    const resellAuctionMinBid = document.getElementById("resell_min_bid").value;

    const resellAuctionTime =
      document.getElementById("resell_time_needed").value;
    const timeInSec = resellAuctionTime * 60 * 60;

    const id_to_auction = id;
    const contract_abi = abi;
    const web3 = new Web3(window.ethereum);
    const resellMinBid = web3.utils.toWei(resellAuctionMinBid, "ether");
    const accounts = await web3.eth.getAccounts();
    const contract = new web3.eth.Contract(contract_abi, contractAddress);

    try {
      contract.methods
        .putOnAuction(id_to_auction, timeInSec, resellMinBid)
        .send({ from: accounts[0] })
        .then(function (resellAuctionRes) {
          if (resellAuctionRes) {
            toast.success("NFT is on Auction Now", { theme: "colored" });
          } else {
            toast.error("An error Accoured", { theme: "colored" });
          }
        });
    } catch (error) {
      toast.error("An error Accoured" + error, { theme: "colored" });
    }
  }

  /*---------------------------
        Close Auction
  -----------------------------*/

  async function closeAuction() {
    const contract_address = "0x0c24491c7CadACc878474047c5d7972340D392C3";
    const contract_abi = abi;
    const web3 = new Web3(window.ethereum);
    const contract = new web3.eth.Contract(contract_abi, contract_address);

    try {
      const closeAuctionResult = await contract.methods.closeAuction(id).call();
      if (closeAuctionResult.status) {
        toast.success("Auction Cloased", { theme: "colored" });
      } else {
        if (!closeAuctionResult.status) {
          alert("Only The Owner can close the Auction");
        }
      }
    } catch (err) {
      alert("Only The Owner can close the Auction:  " + err);
    }
  }

  /*---------------------------------------
           GET SINGLE NFT DETAILS
   -----------------------------------------*/
  async function getSingleNftDetails(id) {
    const id_to_fetch = id;
    const myItemsMetadataoptions = {
      address: contractAddress,
      token_id: id_to_fetch,
      chain: "bsc",
    };
    const nftDetails = await Moralis.Web3API.token.getTokenIdMetadata(
      myItemsMetadataoptions
    );
    const userAddress = user.get("ethAddress");
    console.log("Current User:  " + userAddress);
    if (userAddress === nftDetails.owner_of) {
      setOwnerVisit(true);
    }
    //console.log("the owner of this NFT is", nftDetails.owner_of);

    /*Blockchain Function calls*/
    const contract_address = "0x0c24491c7CadACc878474047c5d7972340D392C3";
    const contract_abi = abi;
    const web3 = new Web3(window.ethereum);
    const contract = new web3.eth.Contract(contract_abi, contract_address);

    const nftCreator = await contract.methods.getNftCreator(id_to_fetch).call();
    const nftPrice = await contract.methods.getPrice(id_to_fetch).call();
    const isForSale = await contract.methods.isNftForSale(id_to_fetch).call();
    const isForAuction = await contract.methods
      .isNftOnAuction(id_to_fetch)
      .call();
    const minBidPrice = await contract.methods
      .getMinBidPrice(id_to_fetch)
      .call();
    const nftHeighestBid = await contract.methods
      .getWinningBid(id_to_fetch)
      .call();

    const bidingRunnerUpAddress = await contract.methods.getRunnerup(id).call();
    const bidingRunnerUpBid = await contract.methods.getRunnerupBid(id).call();
    const tokenURI = await contract.methods.tokenURI(id_to_fetch).call();
    console.log("Min  Bid  " + bidingRunnerUpBid);
    console.log("Min  Bidder address  " + bidingRunnerUpAddress);
    if (nftHeighestBid > 0) {
      setisTheirBidder(true);
    }

    try {
      const bidingTime = await contract.methods
        .getRemainingBidingTime(id_to_fetch)
        .call()
        .then(function (bidTimeRes) {
          setIsBiddingOpen(true);
        });
      console.log(bidingTime);
    } catch (err) {
      console.log("Error Accoured which means no time left for bidding");
      setIsBiddingOpen(false);
    }

    const nftPriceEth = Web3.utils.fromWei(nftPrice, "ether");
    const minBidPriceEth = Web3.utils.fromWei(minBidPrice, "ether");
    const nftHeighestBidEth = Web3.utils.fromWei(nftHeighestBid, "ether");

    setSingleNftCreator(nftCreator);
    setnftPrice(nftPriceEth);
    setnftOwner(nftDetails.owner_of);
    if (isForSale) {
      setForSale(true);
    }
    if (isForAuction) {
      setForAuction(true);
      setMinBid(minBidPriceEth);
      setHeighestBid(nftHeighestBidEth);
    }

    //alert( isForSale);

    var obj;
    await fetch(tokenURI)
      .then((res) => res.json())
      .then((data) => (obj = data))
      .then(() => console.log(obj.image));
    setnftRoyality(obj.royalty);

    const nftDetailsBundle = {
      nftImage: obj.image,
      nftName: obj.nftName,
      nftDesc: obj.nftDescription,
      nftRoyality: obj.royalty,
      nftOwner: nftDetails.owner_of,
      nftCreator: nftCreator,
      nftPrice: nftPriceEth,
    };

    nftDetailsArray.push(nftDetailsBundle);
    setNftDetails(nftDetailsArray);
  }
  /*---------------------------------------------
        END OF GET NFT DETAILS FUNCTION
  ------------------------------------------------*/

  return (
    <div className="container grand_parent_div">
      <div className="row">
        {nftDetails.map((curElem) => {
          return (
            <div className="row">
              <ToastContainer />
              <div className="col-md-6 single_nft_img_col">
                <img
                  src={curElem.nftImage}
                  width="250px"
                  height="300px"
                  alt={curElem.nftName}
                />
              </div>

              <div className="col-md-6">
                <h2 className="single_nft_title ">{curElem.nftName}</h2>
                <h3 className="single_nft_title single_nft_price">
                  {curElem.nftPrice} MMO
                </h3>
                <span className="sinlge-nft-description-span">
                  <lable className="single-nft-description-lable">
                    Description
                  </lable>
                  <p className="single_nft_description_content">
                    {" "}
                    {curElem.nftDesc}{" "}
                  </p>
                </span>

                <div className="container nft-detail-tabs-div">
                  <Tabs
                    defaultActiveKey="info"
                    id="nft-detail-tabs"
                    className="mb-3"
                  >
                    <Tab eventKey="info" title="Info">
                      <div className="row">
                        <span className="col-md-8 tabs-col tabs-left-col">
                          <lable>Creator</lable>
                          <h4>{curElem.nftCreator}</h4>
                        </span>
                        <span className="col-md-4 tabs-col">
                          <lable>Royality</lable>
                          <h4>{curElem.nftRoyality}%</h4>
                        </span>
                      </div>
                    </Tab>
                    <Tab eventKey="owner" title="Owner">
                      <span className="col-md-8 tabs-col tabs-left-col">
                        <lable>Owned By</lable>
                        <h4>{curElem.nftOwner}</h4>
                      </span>
                    </Tab>
                    <Tab eventKey="bid" title="Bid">
                      <h4 className="not_for_sale_heading text-right">
                        {forAuction && (
                          <div>
                            <h4 className="not-open-for-bid">
                              {" "}
                              Minimum Bid {minBid} MMO{" "}
                            </h4>
                            <h4 className="not-open-for-bid heighest-bid-amount">
                              {" "}
                              Heighest Bid : {heighestBid} (MMO){" "}
                            </h4>
                            {!isBiddingOpen && (
                              <h4 className="biding_closed_txt">
                                {" "}
                                Bidding is Closed{" "}
                              </h4>
                            )}
                          </div>
                        )}
                        {!forAuction && "Bidding not Opend"}
                        {forAuction && (
                          <div>
                            {isBiddingOpen && (
                              <div className="bynow-div">
                                <input
                                  name="bidAmount"
                                  type="number"
                                  id="entred_bid_amount"
                                />
                                <button onClick={placeBid} id="bid_now_btn">
                                  {!loading && "Bid Now"}
                                  {loading && (
                                    <span>
                                      <img
                                        src={button_spinner}
                                        width="25px"
                                        height="25px"
                                      />{" "}
                                      Please wait....
                                    </span>
                                  )}
                                </button>
                              </div>
                            )}

                            {ownerVisit && (
                              <div>
                                {isTheirBidder && (
                                  <button
                                    id="award_winner"
                                    onClick={awardWinner}
                                  >
                                    {" "}
                                    Award Winner{" "}
                                  </button>
                                )}
                                {!isTheirBidder && (
                                  <button
                                    id="close_auction"
                                    onClick={closeAuction}
                                  >
                                    {" "}
                                    Close Auction{" "}
                                  </button>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                      </h4>
                    </Tab>

                    {ownerVisit && (
                      <Tab eventKey="resell" title="Resell">
                        <div className=" resell resell_fixed_price">
                          <label htmlFor="price">NFT Resell Price</label>
                          <input type="number" name="price" id="resell_price" />
                          <button id="resell_fixed_btn" onClick={resellFixed}>
                            Fixed Price Sale
                          </button>
                        </div>

                        <div className="resell resell_auction">
                          <label htmlFor="minbid">Minimum Bid Amount</label>
                          <input
                            type="number"
                            name="minbid"
                            id="resell_min_bid"
                          />
                          <label htmlFor="auctiontime">
                            Time Needed (Hours)
                          </label>
                          <input type="number" id="resell_time_needed" />
                          <button
                            id="resell_auction_btn"
                            onClick={resellAuction}
                          >
                            Auctioned Sale
                          </button>
                        </div>
                      </Tab>
                    )}
                  </Tabs>
                  {forSale && (
                    <div className="bynow-div">
                      <button onClick={purchase}>
                        {!loading && "Buy Now"}
                        {loading && (
                          <span>
                            <img
                              src={button_spinner}
                              width="25px"
                              height="25px"
                            />{" "}
                            Please wait....
                          </span>
                        )}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div> //outer-div
  );
};

export default Singlenft;
